import { connect } from 'react-redux';
import { subscriberConnect } from '../../../Discord/redux/actions';
var mapDispatchToProps = {
    subscriberConnect: subscriberConnect,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=ConnectDiscord.container.js.map